import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetUser = async (uid) => {
  /**
   * input: uid: users id
   * output: user
   * description: fetches user
   */

  try {
    const userDoc = await doc(db, "users", uid);
    const userDocSnapshot = await getDoc(userDoc);
    const userDocDetails = userDocSnapshot.data();
    return userDocDetails;
  } catch (error) {
    console.log(error);
  }
};

export default GetUser;
